// extracted by mini-css-extract-plugin
export default {"heading":"GenerationInput_heading__9+X4s","input":"GenerationInput_input__M-t7x"};